import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { Action } from 'redux';

import {
  COMPLAIN_COMPLAINTS_FETCHED,
  COMPLAIN_FAIL_REQUEST,
  IComplainFailRequest,
} from '../../constants/actionTypes/complain';
import { getModerationComplainMicrofrontend } from '../../services/getModerationComplainMicrofrontend';
import { TThunkAction } from '../../types/redux';

export type TComplainComplaintsFetched = 'complain/complaintsFetched';

export interface IComplainComplaintsFetched extends Action<TComplainComplaintsFetched> {
  manifest: IMicrofrontendManifest | null;
  type: TComplainComplaintsFetched;
}

export interface IGetComplaintsParameters {
  offerCategoriesIds: number[];
  regionId?: number | null;
  offerId: number;
}

/* istanbul ignore next */
export function getComplaints(): TThunkAction {
  return (dispatch, getState, context) => {
    const { httpApi, logger, microfrontendsRegistry } = context;

    return getModerationComplainMicrofrontend({ httpApi, logger })
      .then(manifest => {
        if (manifest) {
          microfrontendsRegistry.register(manifest);
        }
        dispatch<IComplainComplaintsFetched>({
          manifest,
          type: COMPLAIN_COMPLAINTS_FETCHED,
        });
      })
      .catch(() => {
        dispatch<IComplainFailRequest>({
          isError: true,
          type: COMPLAIN_FAIL_REQUEST,
        });
      });
  };
}
